import { Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";
import {
  Bars3Icon,
  LifebuoyIcon,
  NewspaperIcon,
  PhoneIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import Logo from "../logo-removebg-preview.png";

const navigation = [
  { name: "Changelog", href: "#" },
  { name: "About", href: "#" },
  { name: "Partners", href: "#" },
  { name: "News", href: "#" },
];
const supportLinks = [
  {
    name: "تماس با پشتیبانی",
    href: "#",
    description:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است",
    icon: PhoneIcon,
  },
  {
    name: "چت آنلاین",
    href: "#",
    description:
      "لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است",
    icon: LifebuoyIcon,
  },
];
const faqs = [
  {
    id: 1,
    question: "الگوریتم گزینه دقیقا چکار می کند؟",
    answer:
      "تعداد مقایسه زوجی مخصوصا وقتی که تعداد معیارها زیاد (بیشتر از 3) باشد سر به فلک می زند! مثلا اگر برای خرید یک خانه 5 معیار محله، تعداد اتاق، متراژ و داشتن پارکینگ مد نظر شما باشد و هر کدام از این معیارها 5 حالت (خیلی بد تا خیلی خوب) داشته باشند تعداد مقایسه زوجی که شما باید پاسخ دهید که اهمیت نسبی معیارهاتان مشخص شود 000/881/1 سوال است! الگوریتم ابتکاری ما این تعداد را به حدود 35 سوال کاهش می دهد.",
  },
  {
    id: 2,
    question: "الگوریتم گزینه چقدر معتبر است؟",
    answer:
      "الگوریتم مورد استفاده در گزینه ترکیبی است از چندین مدل ریاضی پیچیده که نتایج آن در معتبرترین ژورنالهای بین المللی چاپ شده و دارای پتنت در چندین کشور اروپایی و آمریکایی است. ",
  },
  {
    id: 3,
    question: "کاربردهای گزینه چه هستند؟",
    answer:
      "گزینه یک دستیار تصمیم گیری است که در همه زمینه ها کاربرد دارد. اگر می خواهید یک موبایل بخرید گزینه به شما کمک می کند که بهترین انتخاب را با توجه به معیارهای خود داشته باشید. اگر مدیر یک سازمان هستید گزینه به شما کمک می کند در همه مسائل پیش روی خود مثلا استخدام پرسنل انتخاب مناسبی داشته باشید. اگر پزشک هستید گزینه در انتخاب روش درمانی برای یک بیمار خاص به شما می کند. خلاصه اینکه در هر زمینه ای که فکرش را بکنید گزینه می تواند به شما کمک کند.",
  },
  {
    id: 4,
    question: "استفاده از گزینه چه فایده ای دارد؟",
    answer:
      "گزینه به شما کمک می کند که اهمیت معیارهای خودتان را بدانید و ساده تر، سریعتر و درست تر تصمیم بگیرید. گزینه از این طریق زمان و هزینه های شما را کاهش می دهد و احتمال خطا در تصمیم گیری را کاهش می دهد. ",
  },
  {
    id: 5,
    question: "آیا در گزینه از هوش مصنوعی استفاده شده است؟",
    answer:
      "نه! اتفاقا در شرایطی که هوش مصنوعی در حال گسترش نفوذ خود در همه زمینه ها است و دارد جای انسان می گیرد تمرکز گزینه بر تصمیم گیری توسط خود شخص است. در نهایت این شما هستید نه کس دیگری که تصمیم گیری می کند. ما فقط به شما کمک می کنید که انتخابهای بهتری داشته باشید. البته در آینده در بخشی از الگوریتم گزینه از هوش مصنوعی هم استفاده خواهد شد اما با این شرط که در تصمیم گیری ها تاثیری نداشته باشد. ",
  },
  {
    id: 6,
    question: "منظور از ترجیحات (Preferences) چیست؟",
    answer:
      "ترجیحات شما همان معیارهایی هستند که شما بر اساس آن تصمیم گیری و انتخاب می کنید. مثلا اگر در حال انتخاب رشته هستید امکان ادامه تحصیل، سخت بودن رشته و درآمد آتی می تواند معیارهای تصمیم گیری شما باشد. ",
  },
  {
    id: 7,
    question: "تحلیل زوجی (Conjoint Analysis) چیست؟",
    answer:
      "برای معیار اهمیت نسبی و وزن معیارها از تجزیه و تحلیل مقایسه زوجی یا مقایسه دوگانه استفاده می شود. این روش کمک می کند که اهمیت تعدادی از گزینه ها را نسبت به یکدیگر بسنجیم. این روش مخصوصا در جایی که اولویت ها واضح نیستند، جایی که گزینه ها کاملا متفاوت هستند، جایی که معیارهای ارزیابی ذهنی هستند یا جایی که گزینه ها از نظر اهمیت با هم رقابت دارند کاربرد زیادی دارد. این ابزار چارچوبی را برای مقایسه هر گزینه در برابر دیگر گزینه ها فراهم می کند و تفاوت اهمیت بین گزینه ها را نشان می دهد. ",
  },
];

export default function About() {
  return (
    <div className="bg-white">
      <header className="relative bg-slate-800 pb-36">
        <div className="absolute inset-0">
          <img
            className="h-full w-full object-cover"
            src="https://images.unsplash.com/photo-1525130413817-d45c1d127c42?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1920&q=60&&sat=-100"
            alt=""
          />
          <div
            className="absolute inset-0 bg-slate-800 mix-blend-multiply"
            aria-hidden="true"
          />
        </div>
        <Popover as="div" className="relative z-10 invisible">
          <nav
            className="relative mx-auto flex max-w-7xl items-center justify-between px-6 pb-2 pt-6 lg:px-8"
            aria-label="Global"
          >
            <div className="flex flex-1 items-center">
              <div className="flex w-full items-center justify-between lg:w-auto">
                <a href="#">
                  <span className="sr-only">Your Company</span>
                  <img className="h-8 w-auto sm:h-10" src={Logo} alt="" />
                </a>
                <div className="-mr-2 flex items-center lg:hidden">
                  <Popover.Button className="focus-ring-inset relative inline-flex items-center justify-center rounded-md bg-slate-900 bg-opacity-0 p-2 text-white hover:bg-opacity-100 focus:outline-none focus:ring-2 focus:ring-white">
                    <span className="absolute -inset-0.5" />
                    <span className="sr-only">Open main menu</span>
                    <Bars3Icon className="h-6 w-6" aria-hidden="true" />
                  </Popover.Button>
                </div>
              </div>
              <div className="hidden space-x-10 lg:ml-10 lg:flex">
                {navigation.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    className="text-base font-medium text-white hover:text-blue-100"
                  >
                    {item.name}
                  </a>
                ))}
              </div>
            </div>
            <div className="hidden lg:flex lg:items-center lg:space-x-6">
              <a
                href="#"
                className="rounded-md border border-transparent bg-blue-500 px-6 py-2 text-base font-medium text-white shadow-md hover:bg-blue-600"
              >
                Login
              </a>
            </div>
          </nav>

          <Transition
            as={Fragment}
            enter="duration-150 ease-out"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="duration-100 ease-in"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Popover.Panel
              focus
              className="absolute inset-x-0 top-0 origin-top transform p-2 transition lg:hidden"
            >
              <div className="overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
                <div className="flex items-center justify-between px-5 pt-4">
                  <div>
                    <img className="h-8 w-auto" src={Logo} alt="" />
                  </div>
                  <div className="-mr-2">
                    <Popover.Button className="relative inline-flex items-center justify-center rounded-md bg-white p-2 text-slate-400 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500">
                      <span className="absolute -inset-0.5" />
                      <span className="sr-only">Close menu</span>
                      <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                    </Popover.Button>
                  </div>
                </div>
                <div className="pb-6 pt-5">
                  <div className="space-y-1 px-2">
                    {navigation.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className="block rounded-md px-3 py-2 text-base font-medium text-slate-900 hover:bg-slate-50"
                      >
                        {item.name}
                      </a>
                    ))}
                  </div>
                  <div className="mt-6 px-5">
                    <a
                      href="#"
                      className="block w-full rounded-md border border-transparent bg-blue-500 px-4 py-2 text-center font-medium text-white shadow hover:bg-blue-600"
                    >
                      Login
                    </a>
                  </div>
                </div>
              </div>
            </Popover.Panel>
          </Transition>
        </Popover>

        <div className="relative mx-auto mt-24 max-w-md px-6 pb-32 sm:max-w-3xl md:mt-32 lg:max-w-7xl lg:px-8">
          <h1 className="text-4xl font-bold tracking-tight text-white md:text-5xl lg:text-6xl">
            دستیار تصمیم‌گیر
          </h1>
          <p className="mt-6 max-w-3xl text-xl text-slate-300">
            هدف گزینه تسهیل فرآیند تصمیم گیری و کمک به انتخاب درست است. گزینه یک
            نرم افزار محاسباتی است که با استفاده از یک الگوریتم ابداعی و با
            پرسیدن چند سوال به صورت مقایسه های زوجی ترجیحات افراد و میزان اهمیت
            آنها را مشخص می کند. الگوریتم گزینه با حفظ دقت تصمیم گیری تعداد
            سوالاتی را که لازم است شخص برای رسیدن به ترجیحات خود لازم است پاسخ
            دهد را به شدت کاهش می دهد و این فرآیند را کاربردی می کند.
          </p>
        </div>
      </header>

      <main>
        <div className="bg-slate-50">
          {/* Cards */}
          <section
            className="relative z-10 mx-auto -mt-32 max-w-md px-6 sm:max-w-3xl lg:max-w-7xl lg:px-8"
            aria-labelledby="contact-heading"
          >
            <h2 className="sr-only" id="contact-heading">
              Contact us
            </h2>
            <div className="grid grid-cols-1 gap-y-20 lg:grid-cols-3 lg:gap-x-8 lg:gap-y-0">
              {supportLinks.map((link) => (
                <div
                  key={link.name}
                  className="flex flex-col rounded-2xl bg-white shadow-xl"
                >
                  <div className="relative flex-1 px-6 pb-8 pt-16 md:px-8">
                    <div className="absolute top-0 inline-block -translate-y-1/2 transform rounded-xl bg-blue-600 p-5 shadow-lg">
                      <link.icon
                        className="h-6 w-6 text-white"
                        aria-hidden="true"
                      />
                    </div>
                    <h3 className="text-xl font-medium text-slate-900">
                      {link.name}
                    </h3>
                    <p className="mt-4 text-base text-slate-500">
                      {link.description}
                    </p>
                  </div>
                  <div className="rounded-bl-2xl rounded-br-2xl bg-slate-50 p-6 md:px-8">
                    <a
                      href={link.href}
                      className="text-base font-medium text-blue-700 hover:text-blue-600"
                    >
                      تماس بگیرید
                      <span aria-hidden="true"> &rarr;</span>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </section>

          {/* FAQ */}
          <section
            className="mx-auto max-w-md divide-y-2 divide-slate-200 px-6 py-24 sm:max-w-3xl lg:max-w-7xl lg:px-8 lg:py-32"
            aria-labelledby="faq-heading"
          >
            <h2
              className="text-3xl font-bold tracking-tight text-slate-900"
              id="faq-heading"
            >
              سوالات پرسیده شده
            </h2>
            <div className="mt-6 pt-10">
              <dl className="space-y-10 md:grid md:grid-cols-2 md:grid-rows-2 md:gap-x-8 md:gap-y-12 md:space-y-0">
                {faqs.map((faq) => (
                  <div key={faq.id}>
                    <dt className="text-lg font-medium text-slate-900">
                      {faq.question}
                    </dt>
                    <dd className="mt-2 text-base text-slate-500">
                      {faq.answer}
                    </dd>
                  </div>
                ))}
              </dl>
            </div>
          </section>
        </div>

        {/* CTA Section */}
        <section className="relative bg-white" aria-labelledby="join-heading">
          <div
            className="absolute inset-x-0 hidden h-1/2 bg-slate-50 lg:block"
            aria-hidden="true"
          />
          <div className="mx-auto max-w-7xl bg-blue-600 lg:bg-transparent lg:px-8">
            <div className="lg:grid lg:grid-cols-12">
              <div className="relative z-10 lg:col-span-4 lg:col-start-1 lg:row-start-1 lg:bg-transparent lg:py-16">
                <div
                  className="absolute inset-x-0 h-1/2 bg-slate-50 lg:hidden"
                  aria-hidden="true"
                />
                <div className="mx-auto max-w-md px-6 sm:max-w-3xl lg:max-w-none lg:p-0">
                  <div className="aspect-h-6 aspect-w-10 sm:aspect-h-1 sm:aspect-w-2 lg:aspect-w-1">
                    <img
                      className="rounded-3xl object-cover object-center shadow-2xl"
                      src="https://images.unsplash.com/photo-1507207611509-ec012433ff52?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=934&q=80"
                      alt=""
                    />
                  </div>
                </div>
              </div>

              <div className="relative bg-blue-600 lg:col-span-10 lg:col-start-3 lg:row-start-1 lg:grid lg:grid-cols-10 lg:items-center lg:rounded-3xl">
                <div
                  className="absolute inset-0 hidden overflow-hidden rounded-3xl lg:block"
                  aria-hidden="true"
                >
                  <svg
                    className="absolute bottom-full left-full -translate-x-2/3 translate-y-1/3 transform xl:bottom-auto xl:top-0 xl:translate-y-0"
                    width={404}
                    height={384}
                    fill="none"
                    viewBox="0 0 404 384"
                    aria-hidden="true"
                  >
                    <defs>
                      <pattern
                        id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d"
                        x={0}
                        y={0}
                        width={20}
                        height={20}
                        patternUnits="userSpaceOnUse"
                      >
                        <rect
                          x={0}
                          y={0}
                          width={4}
                          height={4}
                          className="text-blue-500"
                          fill="currentColor"
                        />
                      </pattern>
                    </defs>
                    <rect
                      width={404}
                      height={384}
                      fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)"
                    />
                  </svg>
                  <svg
                    className="absolute top-full -translate-x-1/3 -translate-y-1/3 transform xl:-translate-y-1/2"
                    width={404}
                    height={384}
                    fill="none"
                    viewBox="0 0 404 384"
                    aria-hidden="true"
                  >
                    <defs>
                      <pattern
                        id="64e643ad-2176-4f86-b3d7-f2c5da3b6a6d"
                        x={0}
                        y={0}
                        width={20}
                        height={20}
                        patternUnits="userSpaceOnUse"
                      >
                        <rect
                          x={0}
                          y={0}
                          width={4}
                          height={4}
                          className="text-blue-500"
                          fill="currentColor"
                        />
                      </pattern>
                    </defs>
                    <rect
                      width={404}
                      height={384}
                      fill="url(#64e643ad-2176-4f86-b3d7-f2c5da3b6a6d)"
                    />
                  </svg>
                </div>
                <div className="relative mx-auto max-w-md space-y-6 px-6 py-12 sm:max-w-3xl sm:py-16 lg:col-span-6 lg:col-start-4 lg:max-w-none lg:p-0">
                  <h2
                    className="text-3xl font-bold tracking-tight text-white"
                    id="join-heading"
                  >
                    با ما همکاری کنید
                  </h2>
                  <p className="text-lg text-white">
                    لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و
                    با استفاده از طراحان گرافیک است چاپگرها و متون بلکه روزنامه
                    و مجله در ستون و سطرآنچنان که لازم است
                  </p>
                  <a
                    className="block w-full rounded-md border border-transparent bg-white px-5 py-3 text-center text-base font-medium text-blue-700 shadow-md hover:bg-slate-50 sm:inline-block sm:w-auto"
                    href="#"
                  >
                    تماس و همکاری
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="bg-slate-50" aria-labelledby="footer-heading">
        <h2 id="footer-heading" className="sr-only">
          Footer
        </h2>
        <div className="mx-auto max-w-md px-6 py-12 sm:max-w-7xl lg:px-8 lg:py-16">
          <div className="xl:grid xl:grid-cols-3 xl:gap-8">
            <div className="space-y-8 xl:col-span-1">
              <img className="h-10" src={Logo} alt="Company name" />
              <p className="text-base text-slate-500">
                دستیار هوشمند تصمیم‌گیری
              </p>
              <div className="flex space-x-6"></div>
            </div>
            <div className="mt-12 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
              <div className="md:grid md:grid-cols-2 md:gap-8">
                <div>
                  <h3 className="text-base font-medium text-slate-900">
                    راه‌حل‌های سازمانی
                  </h3>
                  <ul role="list" className="mt-4 space-y-4"></ul>
                </div>
                <div className="mt-12 md:mt-0">
                  <h3 className="text-base font-medium text-slate-900">
                    پشتیبانی
                  </h3>
                  <ul role="list" className="mt-4 space-y-4"></ul>
                </div>
              </div>
              <div className="md:grid md:grid-cols-2 md:gap-8">
                <div>
                  <h3 className="text-base font-medium text-slate-900">
                    صفحات
                  </h3>
                  <ul role="list" className="mt-4 space-y-4"></ul>
                </div>
                <div className="mt-12 md:mt-0">
                  <Link to="/about">
                    <h3 className="text-base font-medium text-slate-900">
                      راهنمایی
                    </h3>
                  </Link>
                  <ul role="list" className="mt-4 space-y-4"></ul>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-12 border-t border-slate-200 pt-8">
            <p className="text-base text-slate-400 xl:text-center">
              &copy; 2023 دستیار تصمیم‌گیر
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
